<input #input [(ngModel)]="newName" type="text" pInputText class="w-full mb-4" (keyup.enter)="doRename()" [maxlength]="100"/>
<div class="flex align-items-center justify-content-end">
    <button pButton type="button" icon="pi pi-times" label="Cancel" (click)="doCancel()" class="mr-2"></button>
    <button pButton type="button" icon="pi pi-check" label="Rename" (click)="doRename()" [disabled]="isRenameDisabled()"></button>
</div>
